import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';

export const CHECK_CADASTRAL_FIELDS = 'CADASTRAL_FIELDS :: CHECK';

export type TCheckCadastralFieldsAction = IReduxAction<typeof CHECK_CADASTRAL_FIELDS>;

export const checkCadastralFields = actionGenerator<typeof CHECK_CADASTRAL_FIELDS>(CHECK_CADASTRAL_FIELDS);
